import { ReactElement } from 'react'
import { CloudSync } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Stack, Typography } from '@mui/material'

interface Props {
  isGenerating: boolean
  onGeneratePreview: () => void
}

// Shown in the viewer for a template item whose preview has not been generated yet
const PreviewPlaceholder = ({ isGenerating, onGeneratePreview }: Props): ReactElement => (
  <Stack
    spacing={1.5}
    alignItems="center"
    sx={theme => ({
      m: 1,
      p: 3,
      backgroundColor: theme.palette.grey[100],
      borderRadius: 1.5,
    })}
  >
    <Typography fontSize={16}>Für dieses Template wurde noch keine Vorschau erzeugt</Typography>
    <LoadingButton
      size="small"
      variant="contained"
      startIcon={<CloudSync />}
      loading={isGenerating}
      loadingPosition="start"
      onClick={onGeneratePreview}
      data-cy="document-manager-generate-preview"
    >
      Vorschau erzeugen
    </LoadingButton>
  </Stack>
)

export default PreviewPlaceholder
